import { parseISO, format, subDays, isEqual, startOfDay } from 'date-fns'

export const diseasesObj = {
  1: 'flu',
  2: 'Covid',
}

function isSameDateIgnoringTime(date1, date2) {
  return isEqual(startOfDay(date1), startOfDay(date2))
}

export const transformRes = (images, latestDate) => {
  const result = images.map((i) => {
    return {
      filename: i.FileName,
      lastModifiedDate: format(
        parseISO(i.LastModified),
        ' dd MMM yyyy hh:mm a'
      ),
      createdDate: i.CreatedOn,
      status: isSameDateIgnoringTime(
        new Date(i.LastModified),
        new Date(latestDate)
      )
        ? 'SUCCESS'
        : 'STALE',
    }
  })

  return result
}

export const formatDate = () => {
  const date = new Date()

  // Options for formatting the date
  const options = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  }

  const formattedDate = date.toLocaleDateString('en-US', options)
  return {
    date,
    formattedDate: formattedDate,
  }
}
